import { useSelector, TypedUseSelectorHook } from 'react-redux';
import { RootState } from 'redux/main';

export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
